import { CampaignPerformancePanel } from '@/components/performance/CampaignPerformancePanel';

type CampaignPerformanceSectionProps = {
  profileId: string;
  campaignId: string;
  campaignName: string;
};

export function CampaignPerformanceSection({
  profileId,
  campaignId,
  campaignName,
}: CampaignPerformanceSectionProps) {
  return (
    <section className="rounded-xl border border-border bg-surface p-4 shadow sm:p-6">
      <CampaignPerformancePanel
        profileId={profileId}
        campaignId={campaignId}
        campaignName={campaignName}
        layout="embedded"
      />
    </section>
  );
}
